// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3x5BM","logo":"styles_logo__GbMRD","disclaimer":"styles_disclaimer__1201M","innerContainer":"styles_innerContainer__3g_XB"};